import { useState } from 'react'
import Button from '../../../components/Button'
import GrileService from '../../../services/grile-service.js'
import { toast } from 'react-toastify'
import { toBase64 } from 'utils'

const UploadSection = () => {
  const [source, setSource] = useState(undefined)
  const [uploading, setUploading] = useState(false)
  const [uploadMessage, setUploadMessage] = useState('')

  const upload = async () => {
    if (uploading) {
      toast.warn('Un fisier este deja in curs de copiere!')
      return
    }

    if (source === undefined) {
      toast.warn('Fisier incorect!')
      return
    }

    setUploading(true)

    const content = (await toBase64(source)).split(',').pop()

    const name = source.name
    const response = await GrileService.uploadFile({
      content: content,
      type: source.type,
      name: name,
      folder: 'explain',
    })

    if (response['error']) {
      toast.warn(response['error'])
    } else {
      setUploadMessage(`<file#${name}#mesaj>`)
    }

    setUploading(false)
  }

  return (
    <div className="rounded-xl border border-brd-primary text-over-ternary-background p-5 bg-container-background mt-4 mb-4">
      <div className="mb-2">Incarca fisier</div>
      <input
        type="file"
        onChange={e => setSource(e.target.files[0])}
        disabled={uploading}
      />

      <Button
        onClick={upload}
        className="bg-btn-primary text-sm w-22 h-10 text-white lg:font-bold px-2 lg:py-2 lg:px-3 rounded disabled:bg-gray-600 mt-2 align-center"
        disabled={uploading}
      >
        Incarca
      </Button>

      {uploadMessage.length > 0 ? (
        <div className="mt-2">
          {
            <button
              onClick={() => {
                navigator.clipboard.writeText(uploadMessage)
              }}
            >
              {uploadMessage}
            </button>
          }
        </div>
      ) : null}
    </div>
  )
}

export default UploadSection
